import type { EpocusEncounter } from "$global-providers/rxdb-provider/collections/epocus-encounter";
import type { EpocusExam } from "$global-providers/rxdb-provider/collections/epocus-exam";
import type { RxCollection } from "rxdb";

type ExamSubmissionState = Pick<EpocusExam, "id" | "status">;

export const isLastExamToSubmit = (
  exams: readonly ExamSubmissionState[],
  examId: string,
): boolean =>
  exams.some((exam) => exam.id === examId) &&
  exams.every((exam) => exam.id === examId || exam.status === "submitted");

/**
 * Status transitions are client-authored — the server replays whatever the
 * client writes — so an encounter that is already reviewed or complete must
 * not be dragged back to pending_review by a late exam submission.
 */
export const submitEncounterForReview = async (
  collection: RxCollection<EpocusEncounter> | null,
  encounterId: string,
  userId: string,
): Promise<void> => {
  if (!collection) return;
  const doc = await collection.findOne(encounterId).exec();
  if (!doc) return;

  const status = doc._data.status;
  if (status !== "draft" && status !== "imported") return;

  if (status === "imported") {
    await doc.incrementalPatch({ status: "draft", performerId: userId });
  }
  await doc.incrementalPatch({ status: "pending_review" });
};
